import React, { useState, useEffect } from "react";
import * as Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import ColoumnsHeader from "../../generic/ColoumnsHeader";
import { DBStatistics } from "../../../../../Containers/vendor/DashBoard/DBCosntants";
import {
  addDays,
  CompareDate,
  getDiffBtnDates,
} from "../../../../utils/dateCalculater";
import { convertRS, handleTickInterval, weeklyDataValue } from "../../utlits";
import NoDataFound from "../../generic/NoDataFound";

export interface ILSColLineChartProps {
  uniqueOrdData: Array<DBStatistics>;
  uniqueTradeData: Array<DBStatistics>;
  uniqueOrdTrdData: Array<DBStatistics>;
}

const LSColLineChart: React.FC<ILSColLineChartProps> = (props) => {
  const [orderTradeData, setOrderTradeData] = useState<any>({
    category: [],
    orders: [],
    trades: [],
    OTR: [],
    tickInterval: 0,
  });

  const [sortedOrdsPrDay, setSortedOrdsPrDay] = useState<Array<any>>([]);
  const [sortedTrdsPrDay, setSortedTrdsPrDay] = useState<Array<any>>([]);
  const [sortedOrdTrdRatio, setSortedOrdTrdRatio] = useState<Array<any>>([]);

  const [disableMenu, setDisableMenu] = useState<boolean>(false);

  const setUpChart = async () => {
    if (
      sortedTrdsPrDay.length > weeklyDataValue ||
      sortedOrdsPrDay.length > weeklyDataValue ||
      sortedOrdTrdRatio.length > weeklyDataValue
    ) {
      let firstDate =
        sortedOrdsPrDay && sortedTrdsPrDay
          ? CompareDate(
              sortedOrdsPrDay[0].key,
              sortedTrdsPrDay[0].key,
              "smallerDate"
            )
          : "";

      let lastDate =
        sortedOrdsPrDay && sortedTrdsPrDay
          ? CompareDate(
              sortedOrdsPrDay[sortedOrdsPrDay.length - 1].key,
              sortedTrdsPrDay[sortedTrdsPrDay.length - 1].key,
              "biggerDate"
            )
          : "";

      let totalWeeks = await getDiffBtnDates(firstDate, lastDate);
      if (totalWeeks % 1 !== 0) {
        totalWeeks = Math.floor(totalWeeks) + 1;
      }
      let getOrderData = [...sortedOrdsPrDay];
      let getTradeData = [...sortedTrdsPrDay];
      let getOrdTrdRatio = [...sortedOrdTrdRatio];

      let category = [];
      let orderData = [];
      let tradeData = [];
      let ordTrdRatioData = [];

      let dateOne = firstDate;
      for (let i = 0; i <= totalWeeks; i++) {
        let seventhDay = await addDays(dateOne, 6);

        // eslint-disable-next-line no-loop-func
        let customOrderData = getOrderData.filter((date: any) => {
          return (
            date.key >= moment(dateOne).format("YYYY-MM-DD") &&
            date.key <= moment(seventhDay).format("YYYY-MM-DD")
          );
        });

        // eslint-disable-next-line no-loop-func
        let customTradeData = getTradeData.filter((date: any) => {
          return (
            date.key >= moment(dateOne).format("YYYY-MM-DD") &&
            date.key <= moment(seventhDay).format("YYYY-MM-DD")
          );
        });
        // eslint-disable-next-line no-loop-func
        let customOrdTrdRatio = getOrdTrdRatio.filter((date: any) => {
          return (
            date.key >= moment(dateOne).format("YYYY-MM-DD") &&
            date.key <= moment(seventhDay).format("YYYY-MM-DD")
          );
        });
        if (customOrderData.length > 0) {
          let sumOfOrder = 0;
          for (let i = 0; i < customOrderData.length; i++) {
            sumOfOrder += parseInt(customOrderData[i].val);
          }

          orderData.push(sumOfOrder);
        } else {
          if (dateOne <= lastDate) {
            orderData.push(0);
          }
        }

        if (customTradeData.length > 0) {
          let sumOfTrade = 0;
          for (let i = 0; i < customTradeData.length; i++) {
            sumOfTrade += parseInt(customTradeData[i].val);
          }
          tradeData.push(sumOfTrade);
        } else {
          if (dateOne <= lastDate) {
            tradeData.push(0);
          }
        }
        if (customOrdTrdRatio.length > 0) {
          let sumOfRatio = 0;
          for (let i = 0; i < customOrdTrdRatio.length; i++) {
            sumOfRatio += parseFloat(customOrdTrdRatio[i].val.split(".")[1]);
            // parseFloat(getOTR[0].val.split(".")[1]
          }
          ordTrdRatioData.push(sumOfRatio);
        } else {
          if (dateOne <= lastDate) {
            ordTrdRatioData.push(0);
          }
        }
        if (dateOne <= lastDate) {
          if (lastDate < seventhDay) {
            category.push(
              `${moment(dateOne).format("YYYY-MM-DD")} to ${moment(
                lastDate
              ).format("YYYY-MM-DD")}`
            );
          } else {
            category.push(
              `${moment(dateOne).format("YYYY-MM-DD")} to ${moment(
                seventhDay
              ).format("YYYY-MM-DD")}`
            );
          }
        }

        dateOne = await addDays(seventhDay, 1);
      }
      let getTickInterval = await handleTickInterval(category.length);

      if (
        category.length > 0 ||
        orderData.length > 0 ||
        tradeData.length > 0 ||
        ordTrdRatioData.length > 0
      ) {
        setOrderTradeData({
          category: [...category],
          orders: [...orderData],
          trades: [...tradeData],
          OTR: [...ordTrdRatioData],
          tickInterval: getTickInterval,
        });
      }
    } else {
      let category: any = [];
      let orderData: any = [];
      let tradeData: any = [];
      let OTRData: any = [];

      //  adding date in catagry of both sortedOrdsPrDay and sortedTrdsPrDay
      sortedOrdsPrDay.forEach((ord: any) => {
        category.push(ord.key);
      });

      sortedTrdsPrDay.forEach((trd: any) => {
        if (!category.includes(trd.key)) {
          category.push(trd.key);
        }
      });

      sortedOrdTrdRatio.forEach((trd: any) => {
        if (!category.includes(trd.key)) {
          category.push(trd.key);
        }
      });

      category.sort();

      // checking if data available for catagry's date then add data otherwise add 0
      if (category.length > 0) {
        category.forEach((cat: any) => {
          if (sortedTrdsPrDay.some((trd: any) => trd.key === cat)) {
            let getTrade = sortedTrdsPrDay.filter((sortTrd: any) => {
              return sortTrd.key === cat;
            });
            tradeData.push(parseInt(getTrade[0].val));
          } else {
            tradeData.push(0);
          }

          if (sortedOrdsPrDay.some((ord: any) => ord.key === cat)) {
            let getOrder = sortedOrdsPrDay.filter((sortOrd: any) => {
              return sortOrd.key === cat;
            });
            orderData.push(parseInt(getOrder[0].val));
          } else {
            orderData.push(0);
          }

          if (sortedOrdTrdRatio.some((otr: any) => otr.key === cat)) {
            let getOTR = sortedOrdTrdRatio.filter((sortOtr: any) => {
              return sortOtr.key === cat;
            });
            OTRData.push(parseFloat(getOTR[0].val.split(".")[1]));
          } else {
            OTRData.push(0);
          }
        });
      }
      let getTickInterval = await handleTickInterval(category.length);

      if (
        category.length > 0 ||
        orderData.length > 0 ||
        tradeData.length > 0 ||
        OTRData.length > 0
      ) {
        setOrderTradeData({
          category: [...category],
          orders: [...orderData],
          trades: [...tradeData],
          OTR: [...OTRData],
          tickInterval: getTickInterval,
        });
      }
    }
  };

  useEffect(() => {
    if (
      props.uniqueOrdData.length > 0 ||
      props.uniqueTradeData.length > 0 ||
      props.uniqueOrdTrdData.length > 0
    ) {
      setDisableMenu(false);
      setSortedOrdsPrDay(props.uniqueOrdData);
      setSortedTrdsPrDay(props.uniqueTradeData);
      setSortedOrdTrdRatio(props.uniqueOrdTrdData);
    } else {
      setDisableMenu(true);
      setSortedOrdsPrDay([]);
      setSortedTrdsPrDay([]);
      setSortedOrdTrdRatio([]);
      setOrderTradeData({
        category: [],
        orders: [],
        trades: [],
        OTR: [],
      });
    }
  }, [props.uniqueOrdData, props.uniqueTradeData, props.uniqueOrdTrdData]);

  useEffect(() => {
    if (
      (sortedOrdsPrDay && sortedOrdsPrDay.length > 0) ||
      (sortedTrdsPrDay && sortedTrdsPrDay.length > 0) ||
      (sortedOrdTrdRatio && sortedOrdTrdRatio.length > 0)
    ) {
      setUpChart();
    }
  }, [sortedOrdsPrDay, sortedTrdsPrDay, sortedOrdTrdRatio]);

  console.log("orderTradeData.category", orderTradeData.category);

  const options = {
    chart: {
      zoomType: "xy",
      height: "300px",
    },
    title: "",
    credits: {
      enabled: false,
    },
    colors: ["#1c9ad6", "#f7943e", "#8ebeff"],
    xAxis: [
      {
        categories: orderTradeData.category,
        crosshair: true,
        tickInterval: orderTradeData.tickInterval,
        labels: {
          formatter: function (this: any): any {
            if (this.value.includes("to")) {
              let splitVal = this.value.split("to");
              return `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
                splitVal[1]
              ).format("DD MMM 'YY")}`;
            } else {
              return moment(this.value).format("DD MMM 'YY"); // clean, unformatted number for year
            } // clean, unformatted number for year
          },
        },
      },
    ],
    yAxis: [
      {
        // Primary yAxis
        title: null,
        margin: "0",
        padding: "0",
        labels: {
          formatter: function (this: any): any {
            let val = convertRS(this.value, 0);
            return val;
          },
        },
      },
      {
        // Secondary yAxis
        title: null,
        labels: {
          format: "{value}",
        },
        opposite: true,
      },
    ],
    tooltip: {
      shared: true,
      formatter: function (this: any): any {
        let tooltipVal = "";
        if (this.points[0].x.includes("to")) {
          let splitVal = this.points[0].x.split("to");
          tooltipVal = `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
            splitVal[1]
          ).format("DD MMM 'YY")}`;
        } else {
          tooltipVal = moment(this.points[0].x).format("DD MMM 'YY");
        }
        return `<b><p className="gray">${tooltipVal}</p></b>
              </br><b><span style="color:${
                this.points[0].color
              }">Client Orders</span> : ${
          this.points[0].y
        }</b></br><b><span  style="color:${
          this.points[1].color
        }">Client Trades</span> : ${
          this.points[1] ? this.points[1].y : 0
        }</b></br><b><span  style="color:${
          this.points[2].color
        }">OTR </span> : ${this.points[2] ? this.points[2].y : 0} %</b>`;
      },
      backgroundColor: "white",
      borderColor: "white",
      borderRadius: 10,
      borderWidth: 0,
      padding: 10,
    },
    legend: {
      symbolRadius: 2,
      itemMarginTop: 0,
      itemMarginBottom: -20,
    },
    series: [
      {
        name: "Orders",
        type: "column",
        data: orderTradeData.orders ? orderTradeData.orders : [],
      },
      {
        name: "Trades",
        type: "column",
        // yAxis: 1,
        data: orderTradeData.trades ? orderTradeData.trades : [],
      },
      {
        name: "OTR",
        type: "spline",
        yAxis: 1,
        data: orderTradeData.OTR ? orderTradeData.OTR : [],
        tooltip: {
          valueSuffix: " %",
        },
      },
    ],
  };
  return (
    <>
      <ColoumnsHeader
        title={"Orders to Trades Ratio"}
        subTitle={"Penalty Clause"}
        isDownload={false}
        disableMenu={disableMenu}
      />
      {disableMenu ? (
        <NoDataFound />
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}
    </>
  );
};

export default LSColLineChart;
